import { mapSceneSingleton } from './mapScene';
import { INITIAL_ZOOM } from './mapViewport';

const MERCURY_X = -549.5666216657851;
const MERCURY_Y = 223.90387947741124;

/**
 * Smoothly animate the map camera back to City Hall (initial position).
 * Can be called from anywhere that imports this function.
 */
export function centerMapOnCityHall() {
  const vp = mapSceneSingleton.viewport;
  if (!vp) return;
  vp.animate({
    position: { x: MERCURY_X, y: MERCURY_Y },
    scale: Math.max(INITIAL_ZOOM, vp.scale.x > 0.5 ? vp.scale.x : 0.5),
    time: 800,
    ease: 'easeInOutCubic',
  });
}

export { MERCURY_X, MERCURY_Y };
